import React, { useId, useState } from "react";

export default function CorporateTeamBuildingFaqSection({ data }) {
  const sectionId = useId();
  const [activeIndex, setActiveIndex] = useState(0);

  if (!data?.items?.length) return null;

  return (
    <section className="dynamic-faq-section" aria-labelledby={`${sectionId}-title`}>
      <div className="container">
        <div className="dynamic-faq-heading text-center">
          <span className="main-title">{data.eyebrow}</span>
          <h2 className="heading" id={`${sectionId}-title`}>{data.title}</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="dynamic-faq-list">
              {data.items.map((item, index) => {
                const isOpen = activeIndex === index;
                const triggerId = `${sectionId}-trigger-${index}`;
                const panelId = `${sectionId}-panel-${index}`;

                return (
                  <div className="dynamic-faq-item" key={item.question}>
                    <h3 className="dynamic-faq-question">
                      <button
                        type="button"
                        className="dynamic-faq-trigger"
                        id={triggerId}
                        aria-expanded={isOpen}
                        aria-controls={panelId}
                        onClick={() => setActiveIndex(isOpen ? null : index)}
                      >
                        <span>{item.question}</span>
                        <span className="dynamic-faq-icon" aria-hidden="true" />
                      </button>
                    </h3>
                    <div id={panelId} role="region" aria-labelledby={triggerId} hidden={!isOpen}>
                      <p className="dynamic-faq-answer">{item.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
